export default "__VITE_ASSET__DzlKAAvF__"